export const countries = [
  "afghanistan",
  "albania",
  "algeria",
  "american samoa",
  "andorra",
  "angola",
  "anguilla",
  "antarctica",
  "antigua and barbuda",
  "argentina",
  "armenia",
  "aruba",
  "australia",
  "austria",
  "azerbaijan",
  "bahamas ",
  "bahrain",
  "bangladesh",
  "barbados",
  "belarus",
  "belgium",
  "belize",
  "benin",
  "bermuda",
  "bhutan",
  "bolivia ",
  "bosnia and herzegovina",
  "botswana",
  "bouvet island",
  "brazil",
  "british indian ocean territory ",
  "brunei darussalam",
  "bulgaria",
  "burkina faso",
  "burundi",
  "cabo verde",
  "cambodia",
  "cameroon",
  "canada",
  "cayman islands ",
  "central african republic ",
  "chad",
  "chile",
  "china",
  "christmas island",
  "cocosislands ",
  "colombia",
  "comoros ",
  "congo ",
  "cook islands ",
  "costa rica",
  "croatia",
  "cuba",
  "curaçao",
  "cyprus",
  "czechia",
  "côte d'ivoire",
  "denmark",
  "djibouti",
  "dominica",
  "dominican republic ",
  "ecuador",
  "egypt",
  "el salvador",
  "equatorial guinea",
  "eritrea",
  "estonia",
  "eswatini",
  "england",
  "ethiopia",
  "falkland islands  [Malvinas]",
  "faroe islands ",
  "fiji",
  "finland",
  "france",
  "french guiana",
  "french Polynesia",
  "french southern territories ",
  "gabon",
  "gambia ",
  "georgia",
  "germany",
  "ghana",
  "gibraltar",
  "greece",
  "greenland",
  "grenada",
  "guadeloupe",
  "guam",
  "guatemala",
  "guernsey",
  "guinea",
  "guinea-bissau",
  "guyana",
  "haiti",
  "holy see ",
  "honduras",
  "hong kong",
  "hungary",
  "iceland",
  "india",
  "indonesia",
  "iran ",
  "iraq",
  "ireland",
  "israel",
  "italy",
  "jamaica",
  "japan",
  "jersey",
  "jordan",
  "kazakhstan",
  "kenya",
  "kiribati",
  "north korea",
  "south korea",
  "kuwait",
  "kyrgyzstan",
  "latvia",
  "lebanon",
  "lesotho",
  "liberia",
  "libya",
  "liechtenstein",
  "lithuania",
  "luxembourg",
  "macao",
  "madagascar",
  "malawi",
  "malaysia",
  "maldives",
  "mali",
  "malta",
  "marshall islands (the)",
  "martinique",
  "mauritania",
  "mauritius",
  "mayotte",
  "mexico",
  "micronesia (federated states of)",
  "moldova (the republic of)",
  "monaco",
  "mongolia",
  "montenegro",
  "montserrat",
  "morocco",
  "mozambique",
  "myanmar",
  "Namibia",
  "nauru",
  "nepal",
  "netherlands (the)",
  "new caledonia",
  "new Zealand",
  "nicaragua",
  "niger (the)",
  "nigeria",
  "niue",
  "norfolk island",
  "northern mariana islands ",
  "norway",
  "oman",
  "pakistan",
  "palau",
  "palestine, state of",
  "panama",
  "papua New guinea",
  "paraguay",
  "peru",
  "philippines (the)",
  "pitcairn",
  "poland",
  "portugal",
  "puerto rico",
  "Qatar",
  "republic of North Macedonia",
  "romania",
  "russian federation (the)",
  "rwanda",
  "réunion",
  "saint barthélemy",
  "saint helena, ascension and tristan da cunha",
  "saint kitts and Nevis",
  "saint lucia",
  "saint martin",
  "saint pierre and Miquelon",
  "saint vincent and the grenadines",
  "samoa",
  "san marino",
  "sao tome and principe",
  "saudi arabia",
  "senegal",
  "serbia",
  "seychelles",
  "sierra leone",
  "singapore",
  "sint maarten",
  "slovakia",
  "slovenia",
  "solomon islands",
  "somalia",
  "south africa",
  "south georgia and the south sandwich islands",
  "south sudan",
  "spain",
  "sri lanka",
  "sudan",
  "suriname",
  "svalbard and jan mayen",
  "sweden",
  "switzerland",
  "syrian arab republic",
  "taiwan",
  "tajikistan",
  "tanzania",
  "thailand",
  "timor-leste",
  "togo",
  "tokelau",
  "tonga",
  "trinidad and tobago",
  "tunisia",
  "turkey",
  "turkmenistan",
  "turks and caicos islands",
  "tuvalu",
  "uganda",
  "ukraine",
  "united arab Emirates",
  "united kingdom of great britain and northern ireland",
  "united states minor outlying islands ",
  "united states of america ",
  "uruguay",
  "uzbekistan",
  "vanuatu",
  "venezuela (bolivarian republic of)",
  "viet Nam",
  "virgin islands (british)",
  "virgin islands (u.s.)",
  "wallis and futuna",
  "western sahara",
  "yemen",
  "zambia",
  "zimbabwe",
];

export const names = [
  "acai",
  "ackee",
  "apple",
  "apricot",
  "avocado",
  "banana",
  "bell pepper",
  "berry",
  "bitter orange",
  "black mulberry",
  "blackberry",
  "breadfruit",
  "cape gooseberry",
  "carambola",
  "carob",
  "cashew apple",
  "chayote",
  "cherimoya",
  "cherry",
  "chili pepper",
  "chokeberry",
  "citron",
  "cloudberry",
  "coconut",
  "cornelian cherry",
  "crab apple",
  "crabapple",
  "crowberry",
  "cucumber",
  "currant",
  "custard apple",
  "damson",
  "date",
  "date palm",
  "dragon fruit",
  "durian",
  "elderberry",
  "feijoa",
  "fig",
  "genip",
  "genipap",
  "gooseberry",
  "gourd",
  "grape",
  "grapefruit",
  "grenadilla",
  "guarana",
  "guava",
  "hackberry",
  "hawthorn",
  "hog plum",
  "huckleberry",
  "jackfruit",
  "jamun",
  "jujube",
  "kiwi",
  "kumquat",
  "legume",
  "lemon",
  "lime",
  "longan",
  "loquat",
  "lychee",
  "macadamia",
  "mandarin",
  "mandarin orange",
  "mango",
  "mangosteen",
  "mayapple",
  "medlar",
  "melon",
  "mulberry",
  "mushroom",
  "nance",
  "navel orange",
  "olive",
  "orange",
  "papaya",
  "passion fruit",
  "peach",
  "peanut",
  "pear",
  "pepper",
  "persimmon",
  "pigface",
  "pineapple",
  "plantain",
  "plum",
  "pomegranate",
  "pomelo",
  "potato",
  "prickly pear",
  "prune",
  "pummelo",
  "pumpkin",
  "quince",
  "quinoa",
  "rambutan",
  "raspberry",
  "rose hips",
  "rosehip",
  "salmonberry",
  "sapodilla",
  "shaddock",
  "snap bean",
  "snowberry",
  "soursop",
  "squash",
  "star apple",
  "star fruit",
  "starfruit",
  "strawberry",
  "sugar apple",
  "sycamore",
  "tamarillo",
  "tamarind",
  "tangelo",
  "tangerine",
  "thimbleberry",
  "tomatillo",
  "tomato",
  "ugli fruit",
  "vanilla",
  "watermelon",
  "wineberry",
  "zucchini",
];
export const animals = [
  "Aardvark",
  "Albatross",
  "Alligator",
  "Alpaca",
  "Ant",
  "Anteater",
  "Antelope",
  "Ape",
  "Armadillo",
  "Donkey",
  "Baboon",
  "Badger",
  "Barracuda",
  "Bat",
  "Bear",
  "Beaver",
  "Bee",
  "Bison",
  "Boar",
  "Buffalo",
  "Butterfly",
  "Camel",
  "Capybara",
  "Caribou",
  "Cassowary",
  "Cat",
  "Caterpillar",
  "Cattle",
  "Chamois",
  "Cheetah",
  "Chicken",
  "Chimpanzee",
  "Chinchilla",
  "Chough",
  "Clam",
  "Cobra",
  "Cockroach",
  "Cod",
  "Cormorant",
  "Coyote",
  "Crab",
  "Crane",
  "Crocodile",
  "Crow",
  "Curlew",
  "Deer",
  "Dinosaur",
  "Dog",
  "Dogfish",
  "Dolphin",
  "Dotterel",
  "Dove",
  "Dragonfly",
  "Duck",
  "Dugong",
  "Dunlin",
  "Eagle",
  "Echidna",
  "Eel",
  "Eland",
  "Elephant",
  "Elk",
  "Emu",
  "Falcon",
  "Ferret",
  "Finch",
  "Fish",
  "Flamingo",
  "Fly",
  "Fox",
  "Frog",
  "Gaur",
  "Gazelle",
  "Gerbil",
  "Giraffe",
  "Gnat",
  "Gnu",
  "Goat",
  "Goldfinch",
  "Goldfish",
  "Goose",
  "Gorilla",
  "Goshawk",
  "Grasshopper",
  "Grouse",
  "Guanaco",
  "Gull",
  "Hamster",
  "Hare",
  "Hawk",
  "Hedgehog",
  "Heron",
  "Herring",
  "Hippopotamus",
  "Hornet",
  "Horse",
  "Human",
  "Hummingbird",
  "Hyena",
  "Ibex",
  "Ibis",
  "Jackal",
  "Jaguar",
  "Jay",
  "Jellyfish",
  "Kangaroo",
  "Kingfisher",
  "Koala",
  "Kookabura",
  "Kouprey",
  "Kudu",
  "Lapwing",
  "Lark",
  "Lemur",
  "Leopard",
  "Lion",
  "Llama",
  "Lobster",
  "Locust",
  "Loris",
  "Louse",
  "Lyrebird",
  "Magpie",
  "Mallard",
  "Manatee",
  "Mandrill",
  "Mantis",
  "Marten",
  "Meerkat",
  "Mink",
  "Mole",
  "Mongoose",
  "Monkey",
  "Moose",
  "Mosquito",
  "Mouse",
  "Mule",
  "Narwhal",
  "Newt",
  "Nightingale",
  "Octopus",
  "Okapi",
  "Opossum",
  "Oryx",
  "Ostrich",
  "Otter",
  "Owl",
  "Oyster",
  "Panther",
  "Parrot",
  "Partridge",
  "Peafowl",
  "Pelican",
  "Penguin",
  "Pheasant",
  "Pig",
  "Pigeon",
  "Pony",
  "Porcupine",
  "Porpoise",
  "Quail",
  "Quelea",
  "Quetzal",
  "Rabbit",
  "Raccoon",
  "Rail",
  "Ram",
  "Rat",
  "Raven",
  "Red deer",
  "Red panda",
  "Reindeer",
  "Rhinoceros",
  "Rook",
  "Salamander",
  "Salmon",
  "Sand Dollar",
  "Sandpiper",
  "Sardine",
  "Scorpion",
  "Seahorse",
  "Seal",
  "Shark",
  "Sheep",
  "Shrew",
  "Skunk",
  "Snail",
  "Snake",
  "Sparrow",
  "Spider",
  "Spoonbill",
  "Squid",
  "Squirrel",
  "Starling",
  "Stingray",
  "Stinkbug",
  "Stork",
  "Swallow",
  "Swan",
  "Tapir",
  "Tarsier",
  "Termite",
  "Tiger",
  "Toad",
  "Trout",
  "Turkey",
  "Turtle",
  "Viper",
  "Vulture",
  "Wallaby",
  "Walrus",
  "Wasp",
  "Weasel",
  "Whale",
  "Wildcat",
  "Wolf",
  "Wolverine",
  "Wombat",
  "Woodcock",
  "Woodpecker",
  "Worm",
  "Wren",
  "Yak",
  "Zebra",
];

export const letters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "z",
];
